import classNames from "classnames";

import textStyles from "@/shared/foundation/styles/textStyles.module.css";

import styles from "./FormPageHeading.module.css";

export interface FormPageHeadingProps {
  /** The heading. */
  title: string;
  /** One line of orientation under it; omitted, the heading stands alone. */
  subtitle?: string;
}

/**
 * What a resource-authoring page leads with, so every one of them opens the
 * same way. The page around it brings its own trail and its own width.
 */
export function FormPageHeading({ title, subtitle }: FormPageHeadingProps) {
  return (
    <header>
      <h1 className={classNames(textStyles.pageTitle, styles.title)}>
        {title}
      </h1>
      {subtitle !== undefined && <p className={styles.lede}>{subtitle}</p>}
    </header>
  );
}
